import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=0c5b5dfb&scoped=true"
import script from "./organizationList.vue?vue&type=script&lang=js"
export * from "./organizationList.vue?vue&type=script&lang=js"
import style0 from "./organizationList.vue?vue&type=style&index=0&id=0c5b5dfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b5dfb",
  null
  
)

export default component.exports